/**
 * Keep ALM header cart badge in sync when Dawn's cart-icon-bubble section is not used.
 */
(function () {
  if (!document.querySelector('.alm-site-header')) return;

  function almFormatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function almUpdateHeaderCart(cartData) {
    if (!cartData || typeof cartData.item_count !== 'number') return;
    var count = cartData.item_count;
    var total = cartData.total_price || 0;
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;

    var itemWord = count === 1 ? 'item' : 'items';
    bubble.setAttribute('aria-label', 'Cart (' + count + ' ' + itemWord + ')');

    if (bubble.classList.contains('hdrB__bag')) {
      var bSpan = bubble.querySelector('span');
      if (bSpan) {
        var moneyPart = total > 0 ? ' · ' + almFormatMoney(total) : '';
        bSpan.textContent = 'Bag · ' + count + moneyPart;
      }
      return;
    }

    if (bubble.classList.contains('hdrC__bag')) {
      var cSpan = bubble.querySelector('span');
      if (cSpan) cSpan.textContent = 'Bag ' + count;
      return;
    }

    var badge = bubble.querySelector('[data-cart-count]');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'hdrA__bag-count';
        badge.setAttribute('data-cart-count', '');
        bubble.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  function almFetchAndUpdateCart() {
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(almUpdateHeaderCart)
      .catch(function () {});
  }

  function almRegisterCartSync() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      almFetchAndUpdateCart();
    });
  }

  if (document.readyState === 'complete') {
    almRegisterCartSync();
  } else {
    window.addEventListener('load', almRegisterCartSync);
  }
})();
